import styled, { css } from "styled-components";
import { neutral1, neutral10, neutral6, brandhighlight, } from "../../../../css/colors";
import { media } from "../../../../css/breakpoints";
export const primaryFontFamily = "Roboto-Regular, sans-serif";
export const primaryFontFamilyBold = "Roboto-Bold, sans-serif";
export const Container = styled.div `
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
`;
export const InnerContainer = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
export const RootContainer = styled.div `
  width: 100%;
  min-width: 300px;
  height: 100%;
  position: relative;
  outline: 0px;
`;
export const ErrorRoot = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${neutral1};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  body {
    -webkit-font-smoothing: antialiased; /* Chrome, Safari */
    -moz-osx-font-smoothing: grayscale; /* Firefox */
  }

  &,
  & * {
    box-sizing: border-box;
  }
`;
export const ErrorIconContainer = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 40px;
  width: 30vh;
  ${media.mobileDown} {
    display: none;
  }
`;
export const ErrorMessageContainer = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  ${media.mobileDown} {
    padding: 10px;
  }
`;
export const ErrorCode = styled.div `
  font-family: ${primaryFontFamily};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.4px;
  text-align: left;
  color: ${neutral6};
  font-size: 14px;
  line-height: 1.2;
  ${media.mobileDown} {
    text-align: center;
    line-height: 16px;
  }
`;
export const ErrorMessageTitle = styled.div `
  font-family: ${primaryFontFamilyBold};
  color: ${neutral10};
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.5px;
  font-size: 20px;
  text-align: left;
  width: 100%;
  max-width: 520px;
  font-weight: 600;
  margin-bottom: 12px;
  margin-top: 8px;
  line-height: 24px;
  ${media.mobileDown} {
    font-size: 16px;
    text-align: center;
  }
`;
export const ErrorInformationText = styled.div `
  width: 100%;
  max-width: 552px;
  margin-bottom: 16px;
  font-family: ${primaryFontFamily};
  font-stretch: normal;
  font-style: normal;
  line-height: 12px;
  letter-spacing: 0.4px;
  text-align: left;
  font-size: 18px;
  line-height: normal;
  color: ${neutral6};
  ${media.mobileDown} {
    font-size: 14px;
    text-align: center;
  }
`;
export const HelpCenter = styled.div `
  position: absolute;
  bottom: 5vh;
  text-align: left;
  color: ${neutral6};
  display: flex;
  width: 100%;
  font-size: 14px;
  font-family: ${primaryFontFamily};
  ${media.mobileDown} {
    position: relative;
    display: flex;
    justify-content: center;
    bottom: 0;
  }
`;
export const Link = styled.div `
  font-family: ${primaryFontFamily};
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: 1px;
  color: ${neutral10};
  padding-left: 4px;
`;
export const SignInLink = styled.a `
  font-family: ${primaryFontFamily};
  color: ${brandhighlight};
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.4px;
  text-align: center;
  line-height: 18px;

  ${media.mobileDown} {
    line-height: 16px;
  }
`;
const mediumOutlinedButton = css `
  border-radius: 10px;
  border: solid 2px ${brandhighlight};
  background-color: ${brandhighlight};
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  font-family: ${primaryFontFamily};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${neutral10};
  cursor: pointer;

  width: 139px;
  height: 47px;
  font-size: 14px;

  &:hover {
    border-radius: 10px;
    background-color: ${brandhighlight};
    color: ${neutral1};
  }
`;
export const ErrorButton = styled.a `
  ${mediumOutlinedButton}
  ${media.mobileDown} {
    margin-bottom: 10px;
    align-self: center;
  }
`;

